import { render, staticRenderFns } from "./GoxipCircleOrderAppealList.vue?vue&type=template&id=31fbce26&scoped=true&"
import script from "./GoxipCircleOrderAppealList.vue?vue&type=script&lang=js&"
export * from "./GoxipCircleOrderAppealList.vue?vue&type=script&lang=js&"
import style0 from "./GoxipCircleOrderAppealList.vue?vue&type=style&index=0&id=31fbce26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fbce26",
  null
  
)

export default component.exports